import { Collapse, List, Typography } from '@mui/material';
import React, { useState } from 'react';

import { ChevronDownIcon } from '@/shared/assets/icons/chevron-down-icon';
import { ChevronUpIcon } from '@/shared/assets/icons/chevron-up-icon';
import { NavigationItem } from '@/shared/features/sidebar/components/navigation-item/navigation-item';
import {
  CustomDivider,
  SectionHeader,
  SectionWrapper,
} from '@/shared/features/sidebar/components/navigation-section/navigation-section.styled';
import { TNavigationSectionProps } from '@/shared/features/sidebar/components/navigation-section/navigation-section.types';
import { TNavigationSection } from '@/shared/features/sidebar/sidebar.types';

export const NavigationSection: React.FC<
  TNavigationSectionProps & TNavigationSection
> = ({ open, ...section }) => {
  const [sectionOpen, setSectionOpen] = useState<boolean>(true);

  const shouldRenderList = () => {
    return !section.name || !open || sectionOpen;
  };

  return (
    <SectionWrapper>
      {section.name &&
        (open ? (
          <SectionHeader onClick={() => setSectionOpen((prev) => !prev)}>
            <Typography color="text.disabled" variant="h7">
              {section.name}
            </Typography>
            {sectionOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
          </SectionHeader>
        ) : (
          <CustomDivider />
        ))}
      <Collapse in={shouldRenderList()}>
        <List disablePadding>
          {section.children
            ?.filter(({ hide }) => !hide)
            .map((item, index) => (
              <NavigationItem
                key={`${index}__${item.name}`}
                {...item}
                open={open}
              />
            ))}
        </List>
      </Collapse>
    </SectionWrapper>
  );
};
